/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunAnswerRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunAnswerRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunAnswerRequest>): WellArchitectedFrameworkAssessmentRunAnswerRequest {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunAnswerRequest(), model);
        WellArchitectedFrameworkAssessmentRunAnswerRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunAnswerRequest>): WellArchitectedFrameworkAssessmentRunAnswerRequest {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunAnswerRequest.newInstance(<WellArchitectedFrameworkAssessmentRunAnswerRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunAnswerRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunAnswerRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunAnswerRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunAnswerRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.answer) {
            models.WellArchitectedFrameworkAssessmentRunAnswer.fixupPrototype(this.answer);
        }
    }

    /**
     * Identity of the Framework
     */
    framework_id: string;

    /**
     * Identity of the Pillar
     */
    pillar_id: string;

    /**
     * Identity of the Question
     */
    question_id: string;

    /**
     * Answer to add to question
     */
    answer: models.WellArchitectedFrameworkAssessmentRunAnswer;

}
